exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".manage-menu[data-v-0c1e0f52]{display:block}.manage-menu li[data-v-0c1e0f52]{font-size:13px}@media (min-width:1650px){.manage-menu[data-v-0c1e0f52]{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c1e0f52","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/navigation/Navigation.vue
// module id = 307
// module chunks = 7